import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
const DrawerStateContext = createContext(undefined);
function DrawerProvider({ children, close, isOpen, isInline, placement, hasOverlay, horizontalMaxWidth, }) {
    const value = {
        close,
        isOpen,
        placement,
        isInline,
        hasOverlay,
        horizontalMaxWidth,
    };
    return (_jsx(DrawerStateContext.Provider, { value: value, children: children }));
}
function useDrawer() {
    const context = useContext(DrawerStateContext);
    if (context === undefined) {
        throw new Error('useDrawer must be used within a DrawerProvider');
    }
    return context;
}
export { DrawerProvider, useDrawer };
//# sourceMappingURL=drawer.context.js.map